
import { configureStore } from '@reduxjs/toolkit'

import pathSlice from './slices/paths'
import loggedSlice from './slices/logged'
import totalDeudaSlice from './slices/totalDeuda'
import iconMapSlice from './slices/iconMap'
import selectClientSlice from './slices/selectClientSlice'
import dataVentaSlice from './slices/dataVentaSlice'
import dateForAppSlice from './slices/dateForApp'
import inspectUserSlice from './slices/inspectUserSlice'


export default configureStore({
    reducer: {
        pathStore: pathSlice,
        loggedStore: loggedSlice,
        totalDeudaStore: totalDeudaSlice,
        icomMapStore: iconMapSlice,
        selectClientStore: selectClientSlice,
        dataVentaStore: dataVentaSlice,
        dateForAppStore: dateForAppSlice,
        inspectUserStore: inspectUserSlice
    },
})